// extracted by mini-css-extract-plugin
export default {"policy-number":"styles_policy-number__MmVI-","skeleton":"styles_skeleton__InBTH","shimmer":"styles_shimmer__qSTVg"};